import { NODE_TYPES } from './node-types';

export const AllowedStatementTypes = [
  'select',
  'create',
  'insert',
  'update',
  'print',
  'printSchema',
  'refresh',
  'sleep',
  'stop',
  'validate',
  'execute',
  'delete',
  'stopifzero',
];

export const AllowedDataframeTypes = [NODE_TYPES.select, NODE_TYPES.insert, NODE_TYPES.update];
